var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHeating(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6_510)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.26 19.23H3.74C2.36 19.23 1.25 18.11 1.25 16.74V7.98001C1.25 6.69001 1.9 5.51001 3 4.82001L8.97 1.07001C9.6 0.680012 10.41 0.680012 11.04 1.07001L17.01 4.82001C18.1 5.51001 18.76 6.69001 18.76 7.98001V16.74C18.76 18.12 17.64 19.23 16.27 19.23H16.26ZM10 1.77001C9.83 1.77001 9.65 1.82001 9.5 1.91001L3.53 5.66001C2.73 6.16001 2.25 7.03001 2.25 7.97001V16.73C2.25 17.55 2.92 18.22 3.74 18.22H16.25C17.07 18.22 17.74 17.55 17.74 16.73V7.98001C17.74 7.03001 17.26 6.17001 16.46 5.67001L10.49 1.92001C10.34 1.82001 10.16 1.78001 9.99 1.78001L10 1.77001Z",
    fill: "#F73434"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.48 16.18C6.35 16.18 6.22 16.13 6.13 16.03C5.93 15.83 5.93 15.52 6.13 15.32C7.63 13.82 6.98 12.83 6.07 11.47C5.18 10.13 4.08 8.46001 6.13 6.41001C6.33 6.21001 6.64 6.21001 6.84 6.41001C7.04 6.61001 7.04 6.92001 6.84 7.12001C5.37 8.59001 6.01 9.57001 6.91 10.92C7.8 12.27 8.92 13.95 6.84 16.03C6.74 16.13 6.61 16.18 6.49 16.18H6.48Z",
    fill: "#F73434"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.05 16.18C9.92 16.18 9.79 16.13 9.7 16.03C9.5 15.83 9.5 15.52 9.7 15.32C11.2 13.82 10.55 12.83 9.64 11.47C8.75 10.13 7.65 8.46001 9.7 6.41001C9.9 6.21001 10.21 6.21001 10.41 6.41001C10.61 6.61001 10.61 6.92001 10.41 7.12001C8.94 8.59001 9.58 9.57001 10.48 10.92C11.37 12.27 12.49 13.95 10.41 16.03C10.31 16.13 10.18 16.18 10.06 16.18H10.05Z",
    fill: "#F73434"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.62 16.18C13.49 16.18 13.36 16.13 13.27 16.03C13.07 15.83 13.07 15.52 13.27 15.32C14.77 13.82 14.12 12.83 13.21 11.47C12.32 10.13 11.22 8.46001 13.27 6.41001C13.47 6.21001 13.78 6.21001 13.98 6.41001C14.18 6.61001 14.18 6.92001 13.98 7.12001C12.51 8.59001 13.15 9.57001 14.05 10.92C14.94 12.27 16.06 13.95 13.98 16.03C13.88 16.13 13.75 16.18 13.63 16.18H13.62Z",
    fill: "#F73434"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6_510"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17.5,
    height: 18.46,
    fill: "white",
    transform: "translate(1.25 0.770004)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeating);
export default __webpack_public_path__ + "static/media/heating.36aae83a26517c97d7a04485f1f8d6ea.svg";
export { ForwardRef as ReactComponent };